import React from 'react';
import { Search } from 'lucide-react';

import { Badge } from '@/Modules/Core/Components/shadcn/badge';
import { Input } from '@/Modules/Core/Components/shadcn/input';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/Modules/Core/Components/shadcn/select';
import { PAGE_SIZE_OPTIONS } from './projectCatalogUtils';

const ProjectsCatalogFilters = ({
  searchTerm,
  onSearchChange,
  showingFrom,
  showingTo,
  filteredCount,
  reportedTotal,
  rowsPerPage,
  onRowsPerPageChange,
}) => (
  <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
    <div className="relative w-full max-w-md">
      <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
      <Input
        value={searchTerm}
        onChange={(event) => onSearchChange(event.target.value)}
        placeholder="Search projects, versions, or status..."
        className="pl-9"
      />
    </div>

    <div className="flex flex-wrap items-center gap-3">
      <Badge variant="secondary" className="rounded-xl px-3 py-1 text-[11px]">
        Showing {showingFrom}-{showingTo} of {filteredCount}
      </Badge>

      {searchTerm && reportedTotal > filteredCount ? (
        <Badge variant="outline" className="rounded-xl px-3 py-1 text-[11px]">
          {reportedTotal} records loaded
        </Badge>
      ) : null}

      <div className="flex items-center gap-2 text-[13px] text-muted-foreground">
        <span>Rows</span>
        <Select value={rowsPerPage} onValueChange={onRowsPerPageChange}>
          <SelectTrigger className="w-[96px]">
            <SelectValue placeholder="10" />
          </SelectTrigger>
          <SelectContent>
            {PAGE_SIZE_OPTIONS.map((option) => (
              <SelectItem key={option} value={option}>
                {option}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  </div>
);

export default ProjectsCatalogFilters;
